var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSnow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7681 21.2999C12.126 21.2999 12.4161 21.0098 12.4161 20.6519C12.4161 20.294 12.126 20.0039 11.7681 20.0039C11.4102 20.0039 11.1201 20.294 11.1201 20.6519C11.1201 21.0098 11.4102 21.2999 11.7681 21.2999Z",
    fill: "url(#paint0_linear_4805_26917)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0084 21.2999C15.3662 21.2999 15.6564 21.0098 15.6564 20.6519C15.6564 20.294 15.3662 20.0039 15.0084 20.0039C14.6505 20.0039 14.3604 20.294 14.3604 20.6519C14.3604 21.0098 14.6505 21.2999 15.0084 21.2999Z",
    fill: "url(#paint1_linear_4805_26917)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2486 21.2999C18.6065 21.2999 18.8966 21.0098 18.8966 20.6519C18.8966 20.294 18.6065 20.0039 18.2486 20.0039C17.8907 20.0039 17.6006 20.294 17.6006 20.6519C17.6006 21.0098 17.8907 21.2999 18.2486 21.2999Z",
    fill: "url(#paint2_linear_4805_26917)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4878 21.2999C21.8457 21.2999 22.1358 21.0098 22.1358 20.6519C22.1358 20.294 21.8457 20.0039 21.4878 20.0039C21.13 20.0039 20.8398 20.294 20.8398 20.6519C20.8398 21.0098 21.13 21.2999 21.4878 21.2999Z",
    fill: "url(#paint3_linear_4805_26917)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7681 26.576C12.126 26.576 12.4161 26.2859 12.4161 25.928C12.4161 25.5701 12.126 25.28 11.7681 25.28C11.4102 25.28 11.1201 25.5701 11.1201 25.928C11.1201 26.2859 11.4102 26.576 11.7681 26.576Z",
    fill: "url(#paint4_linear_4805_26917)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0084 26.5758C15.3662 26.5758 15.6564 26.2857 15.6564 25.9278C15.6564 25.5699 15.3662 25.2798 15.0084 25.2798C14.6505 25.2798 14.3604 25.5699 14.3604 25.9278C14.3604 26.2857 14.6505 26.5758 15.0084 26.5758Z",
    fill: "url(#paint5_linear_4805_26917)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2486 26.5758C18.6065 26.5758 18.8966 26.2857 18.8966 25.9278C18.8966 25.5699 18.6065 25.2798 18.2486 25.2798C17.8907 25.2798 17.6006 25.5699 17.6006 25.9278C17.6006 26.2857 17.8907 26.5758 18.2486 26.5758Z",
    fill: "url(#paint6_linear_4805_26917)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4878 26.576C21.8457 26.576 22.1358 26.2859 22.1358 25.928C22.1358 25.5701 21.8457 25.28 21.4878 25.28C21.13 25.28 20.8398 25.5701 20.8398 25.928C20.8398 26.2859 21.13 26.576 21.4878 26.576Z",
    fill: "url(#paint7_linear_4805_26917)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.148 23.984C10.5059 23.984 10.796 23.6939 10.796 23.336C10.796 22.9781 10.5059 22.688 10.148 22.688C9.79012 22.688 9.5 22.9781 9.5 23.336C9.5 23.6939 9.79012 23.984 10.148 23.984Z",
    fill: "url(#paint8_linear_4805_26917)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3882 23.984C13.7461 23.984 14.0362 23.6939 14.0362 23.336C14.0362 22.9781 13.7461 22.688 13.3882 22.688C13.0304 22.688 12.7402 22.9781 12.7402 23.336C12.7402 23.6939 13.0304 23.984 13.3882 23.984Z",
    fill: "url(#paint9_linear_4805_26917)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6285 23.984C16.9863 23.984 17.2765 23.6939 17.2765 23.336C17.2765 22.9781 16.9863 22.688 16.6285 22.688C16.2706 22.688 15.9805 22.9781 15.9805 23.336C15.9805 23.6939 16.2706 23.984 16.6285 23.984Z",
    fill: "url(#paint10_linear_4805_26917)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8677 23.984C20.2256 23.984 20.5157 23.6939 20.5157 23.336C20.5157 22.9781 20.2256 22.688 19.8677 22.688C19.5098 22.688 19.2197 22.9781 19.2197 23.336C19.2197 23.6939 19.5098 23.984 19.8677 23.984Z",
    fill: "url(#paint11_linear_4805_26917)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9478 17.4425C21.7993 17.4425 23.2982 15.9437 23.2982 14.0922C23.2982 12.2407 21.7993 10.7418 19.9478 10.7418C19.9363 10.7418 19.9248 10.7418 19.9133 10.7418C19.6182 8.07767 17.3527 6 14.6003 6C12.4268 6 10.56 7.29567 9.72433 9.15483C9.6975 9.15483 9.67067 9.151 9.64383 9.151C7.35533 9.151 5.5 11.0063 5.5 13.2948C5.5 15.5833 7.35533 17.4387 9.64383 17.4387",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0803 17.4397C21.8702 17.3702 23.298 15.8991 23.298 14.092C23.298 12.2405 21.7992 10.7416 19.9477 10.7416H19.9132C19.9028 10.6484 19.8901 10.5559 19.875 10.4641C20.2421 10.3263 20.6399 10.251 21.0554 10.251C22.7804 10.251 24.2026 11.5543 24.3904 13.2333H24.4134C25.5749 13.2333 26.5179 14.1763 26.5179 15.3378C26.5179 16.4993 25.5749 17.4423 24.4134 17.4423L20.0803 17.4397Z",
    fill: "#CAD1E0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4805_26917",
    x1: 11.12,
    y1: 20.6514,
    x2: 12.4161,
    y2: 20.6514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BDF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4805_26917",
    x1: 14.3602,
    y1: 20.6514,
    x2: 15.6563,
    y2: 20.6514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BDF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4805_26917",
    x1: 17.6004,
    y1: 20.6514,
    x2: 18.8966,
    y2: 20.6514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BDF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4805_26917",
    x1: 20.8397,
    y1: 20.6514,
    x2: 22.1358,
    y2: 20.6514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BDF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4805_26917",
    x1: 11.12,
    y1: 25.9276,
    x2: 12.4161,
    y2: 25.9276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BDF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4805_26917",
    x1: 14.3602,
    y1: 25.9273,
    x2: 15.6563,
    y2: 25.9273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BDF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4805_26917",
    x1: 17.6004,
    y1: 25.9273,
    x2: 18.8966,
    y2: 25.9273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BDF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4805_26917",
    x1: 20.8397,
    y1: 25.9276,
    x2: 22.1358,
    y2: 25.9276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BDF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4805_26917",
    x1: 9.49986,
    y1: 23.3355,
    x2: 10.796,
    y2: 23.3355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BDF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4805_26917",
    x1: 12.7401,
    y1: 23.3355,
    x2: 14.0362,
    y2: 23.3355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BDF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_4805_26917",
    x1: 15.9803,
    y1: 23.3355,
    x2: 17.2764,
    y2: 23.3355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BDF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_4805_26917",
    x1: 19.2196,
    y1: 23.3355,
    x2: 20.5157,
    y2: 23.3355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BDF2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnow);
export default __webpack_public_path__ + "static/media/snow.be8d34908ceaa3e762481c428a847cfc.svg";
export { ForwardRef as ReactComponent };